import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zh from "./locales/zh.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

const resources = {
  zh,
  en,
  fr,
  es,
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",// 默认语言
    fallbackLng: "en",// 切换失败使用的语言

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;